import tags from '../tags';

const {
  passives: {
    offensivePassive,
    defensivePassive,
    resourcePassive,
    mobilityPassive,
    healingPassive,
    cooldownPassive,
  },
} = tags;

export default [
  {
    name: 'Jungle Fortitude',
    tags: [defensivePassive],
  },
  {
    name: 'Circle of Life',
    tags: [],
  },
  {
    name: 'Spiritual Attunement',
    tags: [resourcePassive],
  },
  {
    name: 'Gruesome Feast',
    tags: [resourcePassive, offensivePassive],
  },
  {
    name: 'Blood Ritual',
    tags: [healingPassive],
  },
  {
    name: 'Bad Medicine',
    tags: [defensivePassive],
  },
  {
    name: 'Zombie Handler',
    tags: [defensivePassive],
  },
  {
    name: 'Pierce the Veil',
    tags: [offensivePassive],
  },
  {
    name: 'Spirit Vessel',
    tags: [defensivePassive],
  },
  {
    name: 'Fetish Sycophants',
    tags: [],
  },
  {
    name: 'Rush of Essence',
    tags: [resourcePassive],
  },
  {
    name: 'Vision Quest',
    tags: [resourcePassive],
  },
  {
    name: 'Fierce Loyalty',
    tags: [mobilityPassive],
  },
  {
    name: 'Grave Injustice',
    tags: [resourcePassive, cooldownPassive],
  },
  {
    name: 'Tribal Rites',
    tags: [cooldownPassive],
  },
  {
    name: 'Confidence Ritual',
    tags: [offensivePassive],
  },
  {
    name: 'Creeping Death',
    tags: [],
  },
  {
    name: 'Swampland Attunement',
    tags: [defensivePassive],
  },
  {
    name: 'Midnight Feast',
    tags: [offensivePassive],
  },
];
